var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.select
        ? _c(
            _vm.dialog.comp1,
            _vm._b(
              {
                ref: "menu",
                tag: "component",
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    value: _vm.getValue,
                                    label: _vm.label,
                                    "prepend-inner-icon": _vm.icon,
                                    readonly: "",
                                    rules: _vm.rules,
                                    outlined: "",
                                    dense: "",
                                    "hide-details": _vm.hideDetails,
                                  },
                                },
                                "v-text-field",
                                attrs,
                                false
                              ),
                              on
                            )
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3358749067
                ),
                model: {
                  value: _vm.picker,
                  callback: function ($$v) {
                    _vm.picker = $$v
                  },
                  expression: "picker",
                },
              },
              "component",
              { ..._vm.dialog.props1 },
              false
            ),
            [
              _vm._v(" "),
              _c(
                "v-time-picker",
                {
                  staticClass: "soli-round",
                  attrs: {
                    "allowed-minutes": _vm.allowAll ? null : _vm.allowedStep,
                    "full-width": "",
                    "ampm-in-title": "",
                    format: "ampm",
                    min: _vm.min ?? null,
                  },
                  model: {
                    value: _vm.selected,
                    callback: function ($$v) {
                      _vm.selected = $$v
                    },
                    expression: "selected",
                  },
                },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "primary" },
                      on: {
                        click: function ($event) {
                          ;[(_vm.picker = false), (_vm.original = true)]
                        },
                      },
                    },
                    [_vm._v("\n                Cancel\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.updateTime()
                        },
                      },
                    },
                    [_vm._v("\n                OK\n            ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.select && !_vm.intervals
        ? _c(
            "v-time-picker",
            {
              staticClass: "soli-round custom-time",
              attrs: {
                "allowed-minutes": _vm.allowAll ? null : _vm.allowedStep,
                "full-width": "",
                "ampm-in-title": "",
                format: "ampm",
                "header-color": "transparent",
                min: _vm.min ?? null,
              },
              on: {
                input: function ($event) {
                  return _vm.updateTime()
                },
              },
              model: {
                value: _vm.selected,
                callback: function ($$v) {
                  _vm.selected = $$v
                },
                expression: "selected",
              },
            },
            [
              _c("v-spacer"),
              _vm._v(" "),
              false
                ? _c(
                    "v-btn",
                    {
                      staticClass: "soli-round",
                      attrs: { text: "", color: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.updateTime()
                        },
                      },
                    },
                    [_vm._v("\n            Continue\n        ")]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("v-skeleton-loader", {
            staticClass: "mx-auto",
            attrs: {
              "max-width": "300",
              type: "list-item, list-item, list-item",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.select
        ? _c(
            "div",
            { staticClass: "py-3" },
            [
              /*hasIntervals >= 6 && */ _vm.hasIntervals && !_vm.loading
                ? _c(
                    "v-btn-toggle",
                    {
                      staticClass: "w-full",
                      attrs: { dense: "" },
                      model: {
                        value: _vm.selectedInterval,
                        callback: function ($$v) {
                          _vm.selectedInterval = $$v
                        },
                        expression: "selectedInterval",
                      },
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "justify-start" },
                        _vm._l(_vm.intervals, function (interval) {
                          return _c(
                            "v-col",
                            {
                              key: interval,
                              staticClass: "flex",
                              attrs: { cols: "4" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "font-weight-bold",
                                  class: [
                                    _vm.narrow ? "narrow" : null,
                                    "fixed-width rounded-pill",
                                    _vm.activeInterval == interval
                                      ? "active-btn shadow-blue"
                                      : null,
                                  ],
                                  attrs: {
                                    ripple: false,
                                    value: interval,
                                    outlined: "",
                                    color: "dark",
                                  },
                                  on: {
                                    mousedown: function ($event) {
                                      _vm.activeInterval = interval
                                    },
                                    touchstart: function ($event) {
                                      _vm.activeInterval = interval
                                    },
                                    click: function ($event) {
                                      _vm.$emit("input", interval),
                                        _vm.$emit("selectTime")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      class:
                                        _vm.activeInterval == interval
                                          ? "active-text"
                                          : null,
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(interval) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.hasIntervals && !_vm.loading && _vm.intervals
                ? _c("v-col", { staticClass: "soli-grey py-0" }, [
                    _vm._v(
                      "\n            Sorry, no times are available for this selection\n        "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }